exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mOCRMKBK-MQ5ciGJNMWkK{font-size:10px;line-height:13px;color:#757575}.mOCRMKBK-MQ5ciGJNMWkK a,.mOCRMKBK-MQ5ciGJNMWkK a:hover,.mOCRMKBK-MQ5ciGJNMWkK a:visited,.mOCRMKBK-MQ5ciGJNMWkK a:active,.mOCRMKBK-MQ5ciGJNMWkK a:focus{color:inherit;text-decoration:none}\n", ""]);

// Exports
exports.locals = {
	"disclaimer": "mOCRMKBK-MQ5ciGJNMWkK"
};